import { IListDto } from "../../../interface/dto/list.dto";
import { ITrackedList } from "../../tracked-lists/interface/dto/tracked-lists.dto";
import {
    ListBuilderListActionType,
    IListBuilderListActions,
} from "./list-builder-list.actions";

export interface IListBuilderListState {
    lists: Array<IListDto>;
    isLoading: boolean;
    isTrackedListsLoading: boolean;
    error?: string;
    trackedLists?: Array<ITrackedList>;
}

export const initialListBuilderListState: IListBuilderListState = {
    lists: [],
    isLoading: false,
    isTrackedListsLoading: false,
    trackedLists: undefined,
};

export const listBuilderListReducer = (
    state = initialListBuilderListState,
    action: IListBuilderListActions,
): IListBuilderListState => {
    switch (action.type) {
        case ListBuilderListActionType.LIST_BUILDER_LIST_GET:
            return {
                ...state,
                isLoading: true,
            };
        case ListBuilderListActionType.LIST_BUILDER_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                lists: action.payload.lists,
            };
        case ListBuilderListActionType.LIST_BUILDER_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error,
            };
        case ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS:
            return {
                ...state,
                isTrackedListsLoading: true,
                trackedLists: [],
            };
        case ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_NEXT_PAGE:
            return {
                ...state,
                trackedLists: [
                    ...(state.trackedLists ?? []),
                    ...(action.payload.trackedLists ?? []),
                ],
            };
        case ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_SUCCESS:
            return {
                ...state,
                isTrackedListsLoading: false,
            };
        case ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_ERROR:
            return {
                ...state,
                isTrackedListsLoading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};
